/**
 * ContattoPreferenzeBlock — v1.72.0 (feb-2026).
 *
 * Blocco riusabile "come vuoi essere ricontattato/a" (canale + fascia oraria).
 * Estratto da ConvenzioniPage.jsx (righe 1251-1284) come componente
 * controllato e props-driven per uso cross-wizard.
 *
 * UX identica al pattern RCA convenzioni: 2 select side-by-side, mobile stack.
 */
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const CANALI = [
  { v: "whatsapp", l: "WhatsApp (consigliato)" },
  { v: "telefono", l: "Telefono" },
  { v: "email", l: "Email" },
];

const FASCE = [
  { v: "9-13", l: "Mattina (9-13)" },
  { v: "13-17", l: "Pomeriggio (13-17)" },
  { v: "17-20", l: "Sera (17-20)" },
  { v: "qualsiasi", l: "Qualsiasi" },
];

/**
 * @param {object} props
 * @param {{canale?: string, fascia?: string}} props.value
 * @param {(next:{canale:string,fascia:string}) => void} props.onChange
 * @param {boolean} [props.showFascia=true]
 * @param {boolean} [props.showEmailOption=true]
 * @param {string}  [props.className]
 * @param {string}  [props.testidPrefix="contatto-pref"]
 */
export default function ContattoPreferenzeBlock({
  value = {},
  onChange,
  showFascia = true,
  showEmailOption = true,
  className = "",
  testidPrefix = "contatto-pref",
}) {
  const canaliList = showEmailOption ? CANALI : CANALI.filter((c) => c.v !== "email");
  const set = (patch) => onChange?.({ canale: value.canale || "", fascia: value.fascia || "", ...patch });

  return (
    <div
      className={`grid grid-cols-1 sm:grid-cols-2 gap-4 ${className}`}
      data-testid={`${testidPrefix}-block`}
    >
      <div>
        <Label className="text-xs">Come vuoi essere ricontattato/a?</Label>
        <Select
          value={value.canale || ""}
          onValueChange={(val) => set({ canale: val })}
        >
          <SelectTrigger data-testid={`${testidPrefix}-canale`} className="h-10 text-sm">
            <SelectValue placeholder="Scegli canale" />
          </SelectTrigger>
          <SelectContent>
            {canaliList.map((c) => (
              <SelectItem key={c.v} value={c.v}>{c.l}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {showFascia && (
        <div>
          <Label className="text-xs">Fascia oraria preferita</Label>
          <Select
            value={value.fascia || ""}
            onValueChange={(val) => set({ fascia: val })}
          >
            <SelectTrigger data-testid={`${testidPrefix}-fascia`} className="h-10 text-sm">
              <SelectValue placeholder="Quando ti chiamiamo?" />
            </SelectTrigger>
            <SelectContent>
              {FASCE.map((f) => (
                <SelectItem key={f.v} value={f.v}>{f.l}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
}
